import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters'
import { BlockComponent } from 'lib'
import { Box } from 'components/layout/primitives'
import { LinkButton } from 'ui/inputs/Button'

export interface CalculatorPreviewTileProps {
	sectionTitle: string
	image: JSX.Element
	title: string
	subTitle: string
	text: string
	path: string
}

export const CalculatorPreviewTile: BlockComponent<CalculatorPreviewTileProps> = ({
	sectionTitle,
	image,
	title,
	subTitle,
	text,
	path
}) => {
	return (
		<TopicWrapper>
			<MainTitle>{sectionTitle}</MainTitle>
			<CalcWrapper>
				<Box maxWidth="30vw">{image}</Box>
				<TextContent>
					<Title>{title}</Title>
					<SubTitle>{subTitle}</SubTitle>
					<P>{text}</P>
					<ButtonWrapper>
						<LinkButton href={path}>Get Started</LinkButton>
					</ButtonWrapper>
				</TextContent>
			</CalcWrapper>
		</TopicWrapper>
	)
}

const MainTitle = styled.h2`
	font-size: 32px;
	line-height: 132%;
	margin-bottom: 32px;
`

const TopicWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

const CalcWrapper = styled.div`
	display: flex;
	align-items: center;
	border-radius: 8px;
	box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
	background-color: #ffffff;
	height: 100%;
	padding: 32px;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		flex-direction: column;
		svg {
			width: 100%;
		}
	}
`

const TextContent = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 112px;
	width: 50%;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		margin-left: 24px;
	}
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
		margin-left: 0;
		margin-top: 24px;
		text-align: center;
	}
`

const Title = styled.span`
	font-size: 32px;
	line-height: 132%;
	font-weight: bold;
	margin-bottom: 8px;
`

const SubTitle = styled.span`
	font-weight: bold;
	font-size: 20px;
	line-height: 140%;
	margin-bottom: 24px;
`

const P = styled.span`
	font-size: 16px;
	line-height: 164%;
	margin-bottom: 24px;
`

const ButtonWrapper = styled.div`
	width: 250px;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		margin: 0 auto;
	}
`
